import { Box } from '@hivebrite/design-system/Box';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';
import { TextInput } from '@hivebrite/design-system/Inputs';

import CardPinned from 'hb-react/frontoffice/apps/Forum/components/CardPinned';
import WidgetEmpty from 'hb-react/frontoffice/apps/Forum/components/WidgetEmpty';
import WidgetSide from 'hb-react/frontoffice/apps/Forum/components/WidgetSide';
import { type ConfigUrls, type Widget } from 'hb-react/frontoffice/apps/Forum/types';
import CardForum from 'hb-react/frontoffice/components/CardForum';
import { type Discussion } from 'hb-react/frontoffice/components/CardForum/types';

const SearchIcon = () => (
  <FontAwesomeIcon height="16px" iconName="magnifying-glass" />
);

export const makeItemRenderer =
  (configUrls: ConfigUrls) =>
  ({ item }: { item: Discussion }) => (
    <CardForum discussion={item} configUrls={configUrls} />
  );

export const makePinnedRenderer =
  () =>
  ({ item }: { item: Discussion }) => (
    <Box display="block" height="100%" minHeight="188px">
      <CardPinned {...item} />
    </Box>
  );

export const makeWidgetRenderer =
  () =>
  ({ data }: { data: Array<Widget> }) =>
    data.length === 0 ? (
      <WidgetEmpty />
    ) : (
      <Box flexDirection="column">
        {data.map((widget, index) => (
          <Box display="block" mb={6} key={`${widget.category.id}-${index}`}>
            <WidgetSide {...widget} />
          </Box>
        ))}
      </Box>
    );

export const makeFilters = () => [
  {
    id: 'fulltext',
    component: ({
      id,
      value,
      onChange,
    }: {
      id: string;
      onChange: (value: string) => void;
      value: string;
    }) => (
      <TextInput
        labelMultiline
        clearable
        icon={SearchIcon}
        id={id}
        name={id}
        label={s__('Forum|Search for a discussion')}
        onChange={(e) => onChange(e.target.value)}
        placeholder={__('Type name or keyword')}
        value={value ?? ''}
      />
    ),
  },
];
